export const headerAnim = (selector) => {
    try {
        const header = document.querySelector(selector);
        const nav = header.querySelector('.header__nav_top');
        let active = false;

        window.addEventListener('scroll', function () {
            if (this.pageYOffset != 0) {
                header?.classList.add('active')
                active = true
                setTimeout(function () {
                    if (active) {
                        nav.style.display = 'flex';
                    }
                }, 300)
            } else {
                header?.classList.remove('active')
                active = false;
                nav.style.display = 'none';
            }
        })
    } catch (e) { }
} 
